import React from "react";
import { useAsyncDebounce } from "react-table";
import { TextField, InputAdornment, Tooltip, IconButton, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { faSearch, faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const useStyles = makeStyles(() => ({
    searchFieldRoot: {
        flex: "1 1 auto",
        maxWidth: 600,
        width: "100%",
        minWidth: 200,
    },
}));

type SearchFieldProps = {
    globalFilter;
    setGlobalFilter;
};

export const SearchField = ({ globalFilter, setGlobalFilter }: SearchFieldProps) => {
    const [searchText, setSearchText] = React.useState(globalFilter || "");
    const onChange = useAsyncDebounce((value) => {
        setGlobalFilter(value || undefined);
    }, 200);

    const { t } = useTranslation();

    const classes = useStyles();

    return (
        <TextField
            variant="outlined"
            size="small"
            className={classes.searchFieldRoot}
            value={searchText}
            onChange={(e) => {
                setSearchText(e.target.value);
                onChange(e.target.value);
            }}
            placeholder={t("Gui.Common.FilterPlaceholder")}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Tooltip title={t("Gui.Common.FilterPlaceholder")}>
                            <>
                                <FontAwesomeIcon icon={faSearch} transform="shrink-2" />
                            </>
                        </Tooltip>
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            size="small"
                            disabled={!searchText}
                            onClick={() => {
                                setSearchText("");
                                onChange("");
                            }}
                        >
                            <FontAwesomeIcon icon={faTimes} transform="shrink-6" />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};
